import { useAdministrativeContext } from '../../../../pages/administrativePanel/administrativePanelContext'

import { 
    FaTicketAlt, 
    FaHome, 
    FaUserAlt, 
    FaChartLine, 
    FaSignOutAlt,
    FaTable,
    FaStoreAlt,
    FaReceipt,
    FaCalendarAlt,
    FaBuilding,
    FaAngleDown,
    FaAngleUp,
    FaListOl
} from 'react-icons/fa'

import { useHistory } from 'react-router-dom'
import { useAuth } from '../../../../context/AuthContext'
import { useDispatch } from 'react-redux'
import image from '../../../images/logo.png'

import { Container, ButtonsContainer, HamburguerButton, BusinessButton, SideBarHeader, PeriodButton } from './style'

export function SideBar() {
    const { signOut } = useAuth()

    const { 
            setInformationsToShowInPage, 
            openSideBar, 
            setOpenSideBar,
            openSubMenu,
            setOpenSubMenu,
            openDrop,
            setOpenDrop,
            listDashboardButtons 
    } = useAdministrativeContext()



    const dispatch = useDispatch()
    

    const history = useHistory();

    const setButtons = [
        {
            tag: '1', 
            icon: <FaChartLine />, 
            name: 'Dashboard', 
            info: 'dashboard', 
            subMenu: false, 
            openNav: false
        },
        {
            tag: '2', 
            icon: <FaTicketAlt />, 
            name: 'Cupons', 
            info: 'coupons', 
            subMenu: false, 
            openNav: false
        },
        {
            tag: '4', 
            icon: <FaReceipt />, 
            name: 'Pedidos', 
            info: 'ordersSummary', 
            subMenu: false, 
            openNav: false
        },
        {
            tag: '5', 
            icon: <FaTable />, 
            name: 'Clube', 
            info: 'clube', 
            subMenu: false, 
            openNav: false
        },
        {
            tag: '6', 
            icon: <FaBuilding/>, 
            name: 'Relatório Empresas', 
            info: 'relatory', 
            subMenu: true, 
            openNav: false, 
            menus: [
                {id: '1', name: 'Vendas', info: 'sales', subMenu: false},
                {id: '2', name: 'Curva ABC dos Produtos', info: 'products', subMenu: false},
                {id: '3', name: 'Análise das Empresas', info: 'analysis', subMenu: true, menus:[
                    {id: '1', name: 'Curva ABC das Empresas', info: 'curveAbc'},
                    {id: '2', name: 'Empresas', info: 'oldCompanies'},
                    {id: '3', name: 'Metas', info: 'goals'},
                    {id: '4', name: 'Faturamento Mensal', info: 'monthlyBilling'},
                    {id: '5', name: 'Faturamento por Canal de Venda', info: 'salesChannelBilling'}
                ]}
            ]
        },
        {
            tag: '7',
            icon: <FaListOl/>,
            name: 'Relatório de filas',
            info: 'line',
            subMenu: false,
            openNav: false
        }
    ]

    const listButtonsAllowed = setButtons.filter(datas => listDashboardButtons.some(button => button === datas.tag))

    function close(){
        setOpenDrop(false)
        setOpenSubMenu(false)
        setOpenSideBar(false)
    }

    return(
        <Container openSideBar={openSideBar}>

        <SideBarHeader openSideBar={openSideBar}>
        
            <img src={image} alt="inove logo" />
                <HamburguerButton 
                    onClick={() => {
                        setOpenDrop(false)
                        setOpenSubMenu(false)
                        setOpenSideBar(!openSideBar)
                    }} 
                    openSideBar={openSideBar}
                >
                    <div className="barOne"></div>
                    <div className="barTwo"></div>
                    <div className="barThree"></div>  
                </HamburguerButton>
            
            </SideBarHeader>

            <BusinessButton 
                openSideBar={openSideBar} 
                onClick={() => {
                    setOpenDrop(false)
                    setOpenSubMenu(false)
                    setOpenSideBar(false)
                    dispatch({
                        type: 'OPEN_CENTRALIZEDMODAL', 
                        title: "Filtrar empresas", 
                        componentToShow: 'generalBusinessFilter'
                    })
                }}
            >
                <FaStoreAlt className="busy"/>
            
                <p>Empresas</p>
            </BusinessButton>


            <PeriodButton
                 openSideBar={openSideBar} 
                 onClick={() => {
                    setOpenDrop(false)
                    setOpenSubMenu(false)
                    setOpenSideBar(false)
                    dispatch({
                        type: 'OPEN_CENTRALIZEDMODAL', 
                        title: "Filtrar período", 
                        componentToShow: 'periodFilter'
                    })
                }}
            >
                <FaCalendarAlt />
                <p>Período</p>
            </PeriodButton>


            <ButtonsContainer openSideBar={openSideBar}>
                <div 
                    onClick={() => {
                        setOpenDrop(false)
                        setOpenSubMenu(false)
                        setOpenSideBar(false)
                        setInformationsToShowInPage('home')
                    }}
                >
                    <p><span><FaHome /> Home</span></p>
                </div>
                
                <div 
                    onClick={() => {
                        setOpenSideBar(false)
                        history.push('/profile')
                    }}
                >
                    <p><span><FaUserAlt /> Perfil</span></p>
                </div>

                

                {
                    listButtonsAllowed.map((button,index) => {
                        return(
                            <>
                            <div
                                key={button.tag}
                            >             
                                <p>
                                    <span
                                        onClick={
                                            (button.subMenu && openSideBar === false) ? () => setOpenSideBar(true)
                                            :
                                            (button.subMenu && openSideBar) ? () => {
                                                setOpenSubMenu(!openSubMenu)
                                                setOpenDrop(false)
                                            }
                                            : 
                                            () => {
                                                close()
                                                setInformationsToShowInPage(`${button.info}`)
                                            }
                                        }
                                    >
                                        {button.icon} {button.name} {(button.subMenu && openSideBar) && (openSubMenu ? <FaAngleUp/> : <FaAngleDown/>)}
                                    </span>
                                </p>

                                {
                                        (button.subMenu && openSubMenu) &&
                                        (
                                            <ul>
                                                {button.menus?.map((item) => {
                                                    return(
                                                        <li key={item.id}>
                                                            <span
                                                                onClick={ 
                                                                    item.id === '3' ?
                                                                    () => setOpenDrop(!openDrop)
                                                                    :
                                                                    () => {
                                                                        close()
                                                                        setInformationsToShowInPage(`${item.info}`)
                                                                    }
                                                                }
                                                            >
                                                                {item.name} {item.subMenu && (openDrop ? <FaAngleUp/> : <FaAngleDown/>)}
                                                            </span>

                                                            {(item.subMenu && openDrop) && 
                                                            (
                                                                <ul>
                                                                    {
                                                                        item.menus?.map((value) => {
                                                                            return <li key={value.id}>
                                                                                <span
                                                                                    onClick={
                                                                                        value.id === '2' ?
                                                                                        () => history.push(value.info)
                                                                                        : 
                                                                                        () => {
                                                                                            close()
                                                                                            setInformationsToShowInPage(`${value.info}`)
                                                                                        }
                                                                                    }
                                                                                >
                                                                                    {value.name}
                                                                                </span>
                                                                            </li>
                                                                        })
                                                                    }
                                                                </ul>
                                                            )}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        )
                                }        
                            </div>
                            </>
                        )
                        
                    })
                } 


                
                {/* <div
                    onClick={() => {
                        setOpenSideBar(false)
                        setInformationsToShowInPage('products')
                    }}
                >
                    <FaBoxes />
                    <p>Produtos</p>
                </div>

                <div
                    onClick={() => {
                        setOpenSideBar(false)
                        setInformationsToShowInPage('orders')
                    }}
                >
                    <FaShoppingBag />
                    <p>Pedidos</p>
                </div> */}

                {/* <div
                    onClick={() => {
                        setOpenSideBar(false)
                        setInformationsToShowInPage('loyalty')
                    }}
                >
                    <FaHeart />
                    <p>Fidelidade</p>
                </div> */}


                {/* <div
                    onClick={() => {
                        setOpenSideBar(false)
                        setInformationsToShowInPage('configurations')
                    }}
                >
                    <GoGear />
                    <p>Configurações</p>
                </div> */}
                
            </ButtonsContainer>


            <div className="logOut" onClick={() => {
                    signOut() 
                    history.push('/login') 
                }}>
                <FaSignOutAlt />
                <p>Sair</p>
            </div>

        </Container>
    )
}